type OpenHoursProps = {
  is24Hour: boolean;
  isOpen: boolean;
  openingStatus: string;
  title: string;
  contact?: string;
};

const OpenHours = ({
  is24Hour,
  isOpen,
  openingStatus,
  title,
  contact,
}: OpenHoursProps) => {
  const renderOpen24Hour = () => {
    return (
      <li className="open-hours__container open-hours__container--open ch-display--flex ch-justify-content--between ch-align-items--center">
        <div className="ch-lh--body">
          <span className="ch-fw--500 ch-display--block">{title}</span>
          <div className="open-hours__label--open ch-fs--1">Open 24/7</div>
        </div>
        <div>
          {contact && (
            <a href={`tel:${contact.replace(/\s/g, '')}`}>{contact}</a>
          )}
        </div>
      </li>
    );
  };

  const renderRegularHours = () => {
    return (
      <li
        className={`open-hours__container open-hours__container--${
          isOpen ? 'open' : 'closed'
        } ch-display--flex ch-justify-content--between ch-align-items--center`}
      >
        <div className="ch-lh--body">
          <span className="ch-fw--500 ch-display--block">{title}</span>
          <div className="ch-fs--1">
            <span className={isOpen ? 'open-hours__label--open' : ''}>
              {isOpen ? 'Open now' : 'Closed'}
            </span>{' '}
            - <span>{openingStatus}</span>
          </div>
        </div>
        <div>
          {contact && (
            <a href={`tel:${contact.replace(/\s/g, '')}`}>{contact}</a>
          )}
        </div>
      </li>
    );
  };

  return is24Hour ? renderOpen24Hour() : renderRegularHours();
};

export default OpenHours;
